import { ContentItemProperties } from '@/data/types/Slot';

const contentItems: ContentItemProperties[] = [
    { emsName: 'IT-Revoke-Order-Form-Header-eSpot' },
    { emsName: 'IT-Revoke-Order-Form-Footer-eSpot' },
    { emsName: 'IT-Returns-Product-Display-Message-eSpot' },
    { emsName: 'Return_Order_Complete_Next_Step_1_espot' },
    { emsName: 'Return_Order_Complete_Next_Step_2_espot' },
    { emsName: 'Return_Order_Complete_Next_Step_3_espot' },
    { emsName: 'Return_Order_Complete_Next_Step_4_espot' },
    { emsName: 'Return_order_error_msg_espot' },
    { emsName: 'Return_order_error_page_text_espot' }
];
export default contentItems;
